<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('payItemCompensate.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">{{
                  $t('payItemCompensate.compensateItem')
                }}</label>
                <div>
                  <ts-input
                    v-model="model.compensate_item"
                    :class="{ 'is-invalid': errors.has('compensate_item') }"
                    autofocus
                  />
                  <div class="invalid-feedback" v-if="errors.has('compensate_item')">
                    {{ errors.first('compensate_item') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label">{{ $t('payItemCompensate.customRule') }}</label>
                <div>
                  <ts-select
                    v-model="model.custom_keyword"
                    :options="
                      customRules.map(e => ({
                        text: e.custom_rule,
                        value: e.keyword
                      }))
                    "
                    :class="{ 'is-invalid': errors.has('custom_keyword') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('custom_keyword')">
                    {{ errors.first('custom_keyword') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label">{{ $t('payItemCompensate.description') }}</label>
                <div>
                  <ts-textarea v-model="model.description" rows="3" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <div>
                  <ts-checkbox v-model="model.is_taxable">{{ $t('payItemCompensate.isTaxable') }}</ts-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 text-right">
              <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
              <ts-button
                outline
                color="primary"
                class="ml-2"
                :waiting="savingAndNew"
                @click.prevent="saveAndNew"
                v-if="editData === undefined"
                >{{ $t('button.createAndNew') }}</ts-button
              >
              <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">
                {{ editData ? $t('button.update') : $t('button.create') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'pay-item-compensate-form',
  props: ['editData'],
  data() {
    const model = {
      compensate_item: this.editData ? this.editData.compensate_item : '',
      custom_keyword: this.editData ? this.editData.custom_keyword : '',
      is_taxable: this.editData ? this.editData.is_taxable : false,
      description: this.editData ? this.editData.description : ''
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      loadingPreData: false,
      savingAndNew: false
    }
  },
  computed: {
    ...mapState('hr/payItemCompensate', ['customRules'])
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('hr/payItemCompensate/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/payItemCompensate/update', {
          id: this.editData.compensate_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/payItemCompensate/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/payItemCompensate/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  }
}
</script>
